var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMore2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3264c8",
    fillRule: "evenodd",
    d: "M957.95 428.19L512.01 723.36 66.07 428.19 0 498.44 512.01 864 1024 498.44l-66.05-70.25z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M957.94 230.26L512 528.77 66.07 230.26 132.14 160 512 421.64 891.88 160z",
    fill: "#8fcdff",
    fillRule: "evenodd"
  })));
}
export default SvgMore2;